import { Grid, GridColumn, Notice, TGridColumnWidth, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import BiometryNotice from '../biometry/BiometryNotice';
import LoginButton from '../components/LoginButton';
import { isBiometrySupportedByBrowser } from '../util/BrowserUtil';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';
import RememberMe from './RememberMe';
import useStores from '../stores/UseStores';
import { shouldFixModuleRendering } from '../util/ModuleUtil';

const BiometryLogin = observer((): JSX.Element => {
  const {
    biometryLoginStore,
    biometryStore,
    translateStore: { translate },
    uiStore: { componentWidth, setSelectedTab }
  } = useStores();
  const { submitting } = biometryLoginStore;
  const { isBiometryAvailable, isCredentialsFetching } = biometryStore;

  React.useEffect(() => {
    biometryStore.initBiometry();
  }, []);

  const login = (event: React.FormEvent<HTMLFormElement>) => {
    runInTeliaRumService('Autentimine (Biomeetria)', () => {
      event.preventDefault();
      biometryLoginStore.login();
    });
  };

  const isBiometrySupported = () => {
    return isBiometryAvailable || isCredentialsFetching;
  };

  if (!isBiometrySupportedByBrowser(false)) {
    return <BiometryNotice message="biometry.notEnabledByBrowser" />;
  }

  if (!isBiometrySupported()) {
    return <BiometryNotice message="biometry.notEnabledByDevice" />;
  }

  const gridWidth: TGridColumnWidth[] = ['sm-8', 'md-6', `lg-${shouldFixModuleRendering(componentWidth) ? '10' : '4'}`];

  return (
    <>
      <form onSubmit={(event) => login(event)}>
        <Text>
          <Grid align={['center-sm']}>
            <GridColumn width={gridWidth}>
              <Text>
                <p>{translate('panel.biometry.title')}</p>
                <Notice size="small">
                  <p>{translate('panel.biometry.regNotice')}</p>
                </Notice>
                <RememberMe tabItemId="biometryLoginTab" />
                <LoginButton isLoading={submitting} disabled={!isBiometrySupported() || submitting} onClick={() => setSelectedTab('biometry')} />
              </Text>
            </GridColumn>
          </Grid>
        </Text>
      </form>
    </>
  );
});

export default BiometryLogin;
